import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63187bbe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contact_us" }
const _hoisted_2 = { class: "principally" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title_us" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "联系我们！了解更多...")
], -1))
const _hoisted_4 = { class: "btn" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "联系我们", -1))

import { ref, watch } from "vue";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'contactUs',
  setup(__props) {

const userRouter = useRouter();
const contentShow = ref(true);
watch(
  () => userRouter.currentRoute.value.fullPath,
  (val) => {
    if (val.split("/")[2] === "contactUs") {
      contentShow.value = false;
    } else {
      contentShow.value = true;
    }
  },
  { immediate: true, deep: true }
);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_router_link, { to: "/about/contactUs" }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ])
    ])
  ], 512)), [
    [_vShow, contentShow.value]
  ])
}
}

})